import { serverApi } from 'src/utils/request'
import {
  IAuthTokenDto,
  IGenerateOtpAndSendViaEmailDto,
  IGenerateOtpAndSendViaSmsDto,
  IRiderAuthDetails,
  IUpdateDeviceTokenDto,
  IUserDeviceToken
} from 'src/types/rider-portal'
import Paths from 'src/utils/paths'

class AuthService {
  public async generateOtpAndSendViaEmail(payload: IRiderAuthDetails): Promise<IGenerateOtpAndSendViaEmailDto> {
    const endpoint = Paths.riderPortal.generateOtpAndSendViaEmail
    const result = await serverApi.post<IGenerateOtpAndSendViaEmailDto>(endpoint, { ...payload })
    return result.data
  }

  public async generateOtpAndSendViaSms(payload: IRiderAuthDetails): Promise<IGenerateOtpAndSendViaSmsDto> {
    const endpoint = Paths.riderPortal.generateOtpAndSendViaSms
    const result = await serverApi.post<IGenerateOtpAndSendViaSmsDto>(endpoint, { ...payload })
    return result.data
  }

  public async updateDeviceToken(payload: IUserDeviceToken): Promise<IUpdateDeviceTokenDto> {
    const endpoint = Paths.riderPortal.updateDeviceToken
    const result = await serverApi.post<IUpdateDeviceTokenDto>(endpoint, { ...payload })
    return result.data
  }

  public async verifyOtpCode(payload: IRiderAuthDetails): Promise<IAuthTokenDto> {
    const endpoint = Paths.riderPortal.verifyOtpCode
    const result = await serverApi.post<IAuthTokenDto>(endpoint, { ...payload })
    return result.data
  }
}

const authService = new AuthService()

export { authService }



// WEBPACK FOOTER //
// ./src/services/rider-portal/Auth.ts